<template>
  <div
    class="icon-badge"
    v-b-tooltip.topright.viewport
    :title="tooltipMessage"
    :style="iconStyle"
    @click="onClickIcon"
  >
    <slot>
      <i aria-hidden="true"
        :class="iconClass"
        :style="{ color: iconColor }"
      />
    </slot>
    <b-badge
      v-if="showBadge"
      :style="badgeStyle"
      class="icon-badge__badge"
    >
      <i
        aria-hidden="true"
        :class="badgeIconClass"
        :style="badgeStyle"
      />
    </b-badge>
  </div>
</template>

<script>
export default {
  name: 'IconBadge',
  props: {
    iconColor: {
      type: String,
      required: true,
    },
    iconClass: {
      type: String,
      required: true,
    },
    badgeIconClass: {
      type: String,
      default: '',
    },
    showBadge: {
      type: Boolean,
      default: true,
    },
    badgeColor: {
      type: String,
      default: '',
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    showTooltip: {
      type: Boolean,
      default: false,
    },
    tooltipMessage: {
      type: String,
      default: '',
    },
  },
  computed: {
    badgeStyle() {
      return {
        color: this.badgeColor || this.iconColor,
        'background-color': 'transparent',
      };
    },
    iconStyle() {
      if (!this.outlined) return {};
      return {
        border: `1px solid ${this.iconColor}`,
      };
    },
  },
  methods: {
    onClickIcon() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="sass" scoped>
  .icon-badge
    font-size: 1rem
    display: inline-flex
    align-items: center
    justify-content: center
    padding: .2rem .45rem
    border-radius: 5px
    width: 25px
    height: 25px
    position: relative
    &__badge
      position: absolute
      transform: translate(12px, -7px)
      font-size: 1.1rem
</style>
